/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_StaatsangehoerigkeitInputs */

const de__field_staatsangehoerigkeit = /** @type {(inputs: _Field_StaatsangehoerigkeitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsangehörigkeit`)
};

/**

* @param {_Field_StaatsangehoerigkeitInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_staatsangehoerigkeit = /** @type {((inputs?: _Field_StaatsangehoerigkeitInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_StaatsangehoerigkeitInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_staatsangehoerigkeit(inputs)
});